// extracted by mini-css-extract-plugin
export default {"buttonFooter":"buttonFooter-ziMBNhUY"};